import { render, staticRenderFns } from "./DetailPaneRelatedReferrals.vue?vue&type=template&id=6f13c109&scoped=true&"
import script from "./DetailPaneRelatedReferrals.vue?vue&type=script&lang=ts&"
export * from "./DetailPaneRelatedReferrals.vue?vue&type=script&lang=ts&"
import style0 from "./DetailPaneRelatedReferrals.vue?vue&type=style&index=0&id=6f13c109&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f13c109",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/a/1/s/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VToolbarItems } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon,VList,VListTile,VMenu,VToolbarItems,VToolbarTitle})
